import _asyncToGenerator from "/Users/n8/Development/EtherGrass V2/code/.build/websites/ethergrass.io/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "/Users/n8/Development/EtherGrass V2/code/.build/websites/ethergrass.io/node_modules/@babel/runtime/regenerator";
import { NetworkConnector } from '@web3-react/network-connector';
import { useEffect } from 'react';
import { useEthers } from '../hooks';
import { InjectedConnector } from '@web3-react/injected-connector';
import { useConfig } from './config/context';
export function NetworkActivator() {
  var _useEthers = useEthers(),
      activate = _useEthers.activate,
      account = _useEthers.account,
      connectedChainId = _useEthers.chainId,
      active = _useEthers.active,
      connector = _useEthers.connector;

  var _useConfig = useConfig(),
      supportedChains = _useConfig.supportedChains,
      readOnlyChainId = _useConfig.readOnlyChainId,
      readOnlyUrls = _useConfig.readOnlyUrls;

  useEffect(function () {
    var eagerConnect = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var injected;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                injected = new InjectedConnector({
                  supportedChainIds: supportedChains
                });
                _context.next = 3;
                return injected.isAuthorized();

              case 3:
                if (!_context.sent) {
                  _context.next = 5;
                  break;
                }

                activate(injected);

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function eagerConnect() {
        return _ref.apply(this, arguments);
      };
    }();

    eagerConnect();
  }, []);
  useEffect(function () {
    if (readOnlyChainId && readOnlyUrls) {
      if (!active || connector instanceof NetworkConnector && connectedChainId !== readOnlyChainId) {
        activate(new NetworkConnector({
          defaultChainId: readOnlyChainId,
          urls: readOnlyUrls || []
        }));
      }
    }
  }, [readOnlyChainId, readOnlyUrls, active, account, connectedChainId, connector]);
  return null;
}